import _extends from 'babel-runtime/helpers/extends';

import { interactiveChannelList } from '@com/utils/channel';
import _ from 'lodash';

export default {
  name: 'InteractiveChannelSelector',

  componentName: 'InteractiveChannelSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        placeholder: '请选择适用流量',
        clearable: true,
        disabled: false,
        options: _.cloneDeep(interactiveChannelList).map(function (e) {
          e.value = Number(e.value);
          return e;
        })
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  }
};